<div class="header">
  <spb-logo title="Landing App"></spb-logo>
  <div [style.flex-grow]="1"></div>

  <spb-toggle-button [style.margin-right.px]="10"/>

  @if (service.currentUser()) {
    <span>{{ service.currentUser()?.name }}</span>
    <button
      [style.margin-right.px]="25"
      [matMenuTriggerFor]="menu" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
  }


</div>

<mat-menu #menu="matMenu">
  <button [routerLink]="['/home']" mat-menu-item>Hem</button>
  <button [routerLink]="['/deploy']"
          mat-menu-item>Deploy
  </button>

  @if (helper.isUserAdmin()) {
    <button [routerLink]="['/admin']"
            mat-menu-item>
      Admin
    </button>
  }
  <button [routerLink]="['opening-hours']" mat-menu-item>Öppettider</button>
  <button [routerLink]="['service-catalog']" mat-menu-item>Servicekatalog</button>
  <button [matMenuTriggerFor]="iso27000" mat-menu-item>IS0-27000</button>
  <button [routerLink]="['bolagsverket']" mat-menu-item>Bolagsverket</button>
  <button [matMenuTriggerFor]="tools" mat-menu-item>Verktyg</button>
  <button (click)="service.reset()" mat-menu-item>Logga ut</button>
</mat-menu>

<mat-menu #iso27000="matMenu">
  <button [routerLink]="['compensating-controls']" mat-menu-item>Kompenserande kontroller</button>
</mat-menu>

<mat-menu #tools>
  <button (click)="certs()" mat-menu-item>Förnya certifikat</button>
  <button (click)="confs()" mat-menu-item>Dockeraukorisation</button>
</mat-menu>